import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import { IsEnglish } from '../../utils/language';
import { download } from '../../utils/download';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Dialog from '@material-ui/core/Dialog';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import PdfViewer from '@shared/pdfViewer/PdfViewer';
import styles from '../../styles/timesheet.module.css';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    firstCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "160px"
        },
        textAlign: 'left',
        float: 'left'
    },
    secondCell: {
        float: 'left'
    },
    divWeekSymmary: {
        paddingTop: '6px',
        paddingBottom: '6px'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ScheduleJobFile(props) {
    const classes = useStyles();

    const [dataFiles, setDataFiles] = React.useState(null);
    const [openPdf, setOpenPdf] = React.useState(false);
    const [pdfData, setPdfData] = React.useState('');
    const [filename, setFileName] = React.useState('');
    const [titlePDF, setTitlePDF] = React.useState('');

    const { data } = props;

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        setDataFiles(data);
    }

    const handleClickPdf = (index) => {
        setPdfData(dataFiles[index].documentBase64)
        setFileName(`${dataFiles[index].documentName}.${dataFiles[index].documentType}`);
        setTitlePDF(IsEnglish() ? dataFiles[index].descriptionEn : dataFiles[index].descriptionFr);
        setOpenPdf(true);
    }

    const handleClosePdf = () => {
        setOpenPdf(false);
    }

    const handleDownload = () => {
        const linkSource = `data:application/octet-stream;base64,${pdfData}`;
        download(linkSource, filename, 'application/octet-stream')
    }

    return (
        <div id="divWeekSymmary" className={classes.divWeekSymmary}>
            <List>
                {dataFiles != null && dataFiles.map((obj, index) =>
                    <React.Fragment key={index}>
                        <ListItem button onClick={() => handleClickPdf(obj.index)}>
                            <ListItemIcon className={styles.listItemIcon}>
                                <PictureAsPdf />
                            </ListItemIcon>
                            <ListItemText primary={
                                <React.Fragment>
                                    <div className={classes.secondCell}>{IsEnglish() ? obj.descriptionEn : obj.descriptionFr}</div>
                                </React.Fragment>
                            } />
                        </ListItem>
                    </React.Fragment>
                )}
            </List>
            <Dialog fullScreen open={openPdf} onClose={handleClosePdf} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClosePdf} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            {titlePDF}
                        </Typography>
                        <IconButton edge="start" color="inherit" onClick={handleDownload} aria-label="download">
                            <GetAppIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <PdfViewer pdfData={pdfData} />
            </Dialog>
        </div>
    );
}